var React = require('react');

function ArrowSmallLeft (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"points":"8.5 14.51 2.5 8.5 8.5 2.5","style":{"fill":"none","stroke":"#fff100","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"5px"}}));
}

ArrowSmallLeft.defaultProps = {"viewBox":"0 0 11 17.01"};

module.exports = ArrowSmallLeft;

ArrowSmallLeft.default = ArrowSmallLeft;
